import { Text, TextProps } from '@chakra-ui/react';

export type MobileTitleProps = TextProps;

export const MobileTitle = (props: MobileTitleProps) => {
  return (
    <Text
      fontSize="1.125rem"
      alignSelf="center"
      visibility={['visible', 'visible', 'hidden']}
      display={['flex', 'flex', 'none']}
      {...props}
    />
  );
};
